// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/solid-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTestRouteImport } from './routes/_authenticated/test'
import { Route as AuthenticatedStoreRouteImport } from './routes/_authenticated/store'
import { Route as AuthenticatedTabletRouteRouteImport } from './routes/_authenticated/tablet/route'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthenticatedTabletIndexRouteImport } from './routes/_authenticated/tablet/index'
import { Route as AuthenticatedTabletCreateRouteImport } from './routes/_authenticated/tablet/create'
import { Route as AuthenticatedTabletOrgIdCharacterRouteImport } from './routes/_authenticated/tablet/$orgId/character'
import { Route as AuthenticatedTabletOrgIdTabletRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/route'
import { Route as AuthenticatedTabletOrgIdTabletIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/index'
import { Route as AuthenticatedTabletOrgIdTabletAccountRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/account'
import { Route as AuthenticatedTabletOrgIdTabletVehiclesRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/vehicles/route'
import { Route as AuthenticatedTabletOrgIdTabletSettingsRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/settings/route'
import { Route as AuthenticatedTabletOrgIdTabletPermissionsRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/permissions/route'
import { Route as AuthenticatedTabletOrgIdTabletOffensesRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/offenses/route'
import { Route as AuthenticatedTabletOrgIdTabletEmployeesRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/employees/route'
import { Route as AuthenticatedTabletOrgIdTabletCitizensRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/citizens/route'
import { Route as AuthenticatedTabletOrgIdTabletCasesRouteRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/cases/route'
import { Route as AuthenticatedTabletOrgIdTabletVehiclesIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/vehicles/index'
import { Route as AuthenticatedTabletOrgIdTabletSettingsIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/settings/index'
import { Route as AuthenticatedTabletOrgIdTabletPermissionsIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/permissions/index'
import { Route as AuthenticatedTabletOrgIdTabletOffensesIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/offenses/index'
import { Route as AuthenticatedTabletOrgIdTabletEmployeesIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/employees/index'
import { Route as AuthenticatedTabletOrgIdTabletCitizensIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/citizens/index'
import { Route as AuthenticatedTabletOrgIdTabletCasesIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/cases/index'
import { Route as AuthenticatedTabletOrgIdTabletCitizensCitizenIdIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/citizens/$citizenId/index'
import { Route as AuthenticatedTabletOrgIdTabletCasesCaseIdIndexRouteImport } from './routes/_authenticated/tablet/$orgId/_tablet/cases/$caseId/index'

const AuthenticatedTabletOrgIdRouteImport = createFileRoute('/_authenticated/tablet/$orgId')()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTestRoute = AuthenticatedTestRouteImport.update({
            id: '/test',path: '/test',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStoreRoute = AuthenticatedStoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTabletRouteRoute = AuthenticatedTabletRouteRouteImport.update({
            id: '/tablet',path: '/tablet',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRouteRoute
          })
const AuthenticatedTabletOrgIdRoute = AuthenticatedTabletOrgIdRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => AuthenticatedTabletRouteRoute
          })
const AuthenticatedTabletIndexRoute = AuthenticatedTabletIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletRouteRoute
          })
const AuthenticatedTabletCreateRoute = AuthenticatedTabletCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => AuthenticatedTabletRouteRoute
          })
const AuthenticatedTabletOrgIdCharacterRoute = AuthenticatedTabletOrgIdCharacterRouteImport.update({
            id: '/character',path: '/character',getParentRoute: () => AuthenticatedTabletOrgIdRoute
          })
const AuthenticatedTabletOrgIdTabletRouteRoute = AuthenticatedTabletOrgIdTabletRouteRouteImport.update({
            id: '/_tablet',getParentRoute: () => AuthenticatedTabletOrgIdRoute
          })
const AuthenticatedTabletOrgIdTabletIndexRoute = AuthenticatedTabletOrgIdTabletIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletAccountRoute = AuthenticatedTabletOrgIdTabletAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletVehiclesRouteRoute = AuthenticatedTabletOrgIdTabletVehiclesRouteRouteImport.update({
            id: '/vehicles',path: '/vehicles',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletSettingsRouteRoute = AuthenticatedTabletOrgIdTabletSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletPermissionsRouteRoute = AuthenticatedTabletOrgIdTabletPermissionsRouteRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletOffensesRouteRoute = AuthenticatedTabletOrgIdTabletOffensesRouteRouteImport.update({
            id: '/offenses',path: '/offenses',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletEmployeesRouteRoute = AuthenticatedTabletOrgIdTabletEmployeesRouteRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCitizensRouteRoute = AuthenticatedTabletOrgIdTabletCitizensRouteRouteImport.update({
            id: '/citizens',path: '/citizens',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCasesRouteRoute = AuthenticatedTabletOrgIdTabletCasesRouteRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => AuthenticatedTabletOrgIdTabletRouteRoute
          })
const AuthenticatedTabletOrgIdTabletVehiclesIndexRoute = AuthenticatedTabletOrgIdTabletVehiclesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletVehiclesRouteRoute
          })
const AuthenticatedTabletOrgIdTabletSettingsIndexRoute = AuthenticatedTabletOrgIdTabletSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletSettingsRouteRoute
          })
const AuthenticatedTabletOrgIdTabletPermissionsIndexRoute = AuthenticatedTabletOrgIdTabletPermissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletPermissionsRouteRoute
          })
const AuthenticatedTabletOrgIdTabletOffensesIndexRoute = AuthenticatedTabletOrgIdTabletOffensesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletOffensesRouteRoute
          })
const AuthenticatedTabletOrgIdTabletEmployeesIndexRoute = AuthenticatedTabletOrgIdTabletEmployeesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletEmployeesRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCitizensIndexRoute = AuthenticatedTabletOrgIdTabletCitizensIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletCitizensRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCasesIndexRoute = AuthenticatedTabletOrgIdTabletCasesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTabletOrgIdTabletCasesRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCitizensCitizenIdIndexRoute = AuthenticatedTabletOrgIdTabletCitizensCitizenIdIndexRouteImport.update({
            id: '/$citizenId/',path: '/$citizenId/',getParentRoute: () => AuthenticatedTabletOrgIdTabletCitizensRouteRoute
          })
const AuthenticatedTabletOrgIdTabletCasesCaseIdIndexRoute = AuthenticatedTabletOrgIdTabletCasesCaseIdIndexRouteImport.update({
            id: '/$caseId/',path: '/$caseId/',getParentRoute: () => AuthenticatedTabletOrgIdTabletCasesRouteRoute
          })





const AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletCasesRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletCasesIndexRoute: AuthenticatedTabletOrgIdTabletCasesIndexRoute,AuthenticatedTabletOrgIdTabletCasesCaseIdIndexRoute: AuthenticatedTabletOrgIdTabletCasesCaseIdIndexRoute
}

const AuthenticatedTabletOrgIdTabletCasesRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletCasesRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletCasesRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletCitizensRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletCitizensIndexRoute: AuthenticatedTabletOrgIdTabletCitizensIndexRoute,AuthenticatedTabletOrgIdTabletCitizensCitizenIdIndexRoute: AuthenticatedTabletOrgIdTabletCitizensCitizenIdIndexRoute
}

const AuthenticatedTabletOrgIdTabletCitizensRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletCitizensRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletCitizensRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletEmployeesRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletEmployeesIndexRoute: AuthenticatedTabletOrgIdTabletEmployeesIndexRoute
}

const AuthenticatedTabletOrgIdTabletEmployeesRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletEmployeesRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletEmployeesRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletOffensesRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletOffensesIndexRoute: AuthenticatedTabletOrgIdTabletOffensesIndexRoute
}

const AuthenticatedTabletOrgIdTabletOffensesRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletOffensesRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletOffensesRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletPermissionsRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletPermissionsIndexRoute: AuthenticatedTabletOrgIdTabletPermissionsIndexRoute
}

const AuthenticatedTabletOrgIdTabletPermissionsRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletPermissionsRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletPermissionsRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletSettingsRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletSettingsIndexRoute: AuthenticatedTabletOrgIdTabletSettingsIndexRoute
}

const AuthenticatedTabletOrgIdTabletSettingsRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletSettingsRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletSettingsRouteRouteChildren)




const AuthenticatedTabletOrgIdTabletVehiclesRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletVehiclesIndexRoute: AuthenticatedTabletOrgIdTabletVehiclesIndexRoute
}

const AuthenticatedTabletOrgIdTabletVehiclesRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletVehiclesRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletVehiclesRouteRouteChildren)



const AuthenticatedTabletOrgIdTabletRouteRouteChildren = {
  AuthenticatedTabletOrgIdTabletCasesRouteRoute: AuthenticatedTabletOrgIdTabletCasesRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletCitizensRouteRoute: AuthenticatedTabletOrgIdTabletCitizensRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletEmployeesRouteRoute: AuthenticatedTabletOrgIdTabletEmployeesRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletOffensesRouteRoute: AuthenticatedTabletOrgIdTabletOffensesRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletPermissionsRouteRoute: AuthenticatedTabletOrgIdTabletPermissionsRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletSettingsRouteRoute: AuthenticatedTabletOrgIdTabletSettingsRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletVehiclesRouteRoute: AuthenticatedTabletOrgIdTabletVehiclesRouteRouteWithChildren,AuthenticatedTabletOrgIdTabletAccountRoute: AuthenticatedTabletOrgIdTabletAccountRoute,AuthenticatedTabletOrgIdTabletIndexRoute: AuthenticatedTabletOrgIdTabletIndexRoute
}

const AuthenticatedTabletOrgIdTabletRouteRouteWithChildren = AuthenticatedTabletOrgIdTabletRouteRoute._addFileChildren(AuthenticatedTabletOrgIdTabletRouteRouteChildren)



const AuthenticatedTabletOrgIdRouteChildren = {
  AuthenticatedTabletOrgIdTabletRouteRoute: AuthenticatedTabletOrgIdTabletRouteRouteWithChildren,AuthenticatedTabletOrgIdCharacterRoute: AuthenticatedTabletOrgIdCharacterRoute
}

const AuthenticatedTabletOrgIdRouteWithChildren = AuthenticatedTabletOrgIdRoute._addFileChildren(AuthenticatedTabletOrgIdRouteChildren)



const AuthenticatedTabletRouteRouteChildren = {
  AuthenticatedTabletCreateRoute: AuthenticatedTabletCreateRoute,AuthenticatedTabletIndexRoute: AuthenticatedTabletIndexRoute,AuthenticatedTabletOrgIdRoute: AuthenticatedTabletOrgIdRouteWithChildren
}

const AuthenticatedTabletRouteRouteWithChildren = AuthenticatedTabletRouteRoute._addFileChildren(AuthenticatedTabletRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedTabletRouteRoute: AuthenticatedTabletRouteRouteWithChildren,AuthenticatedStoreRoute: AuthenticatedStoreRoute,AuthenticatedTestRoute: AuthenticatedTestRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRouteWithChildren,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)